import '@mdi/font/css/materialdesignicons.css'
import { createVuetify } from 'vuetify';
import 'vuetify/styles';

const azureTheme = {
  dark: false,
  colors: {
    primary: '#1b5c67',       // color principal del logo (más oscuro)
    secondary: '#58a39e',     // color complementario del logo (más claro)
    accent: '#82c9c5',        // variante más clara para acentos y botones activos

    background: '#f0fafa',    // fondo general suave y claro
    surface: '#ffffff',       // para tarjetas o componentes elevados
    error: '#d13438',         // mantenido para consistencia
    info: '#2ca5bf',          // azul informativo ligeramente adaptado al tema
    success: '#2e7d32',       // verde más sobrio y compatible con el esquema
    warning: '#f0a202',       // naranja dorado más suave

    border: '#d0e3e2',        // borde con tono verdoso claro
    textPrimary: '#1b5c67',   // texto principal en tono fuerte
    textSecondary: '#5d7374', // texto secundario más suave pero relacionado

    hover: '#e0f2f1',         // fondo sutil al hacer hover

    fondo_toolbar: '#1b5c67',     // mismo color del logo para barras superiores
    salmon_oscuro: '#eb8f85',     // si ya está en uso, se mantiene
    white: '#ffffff',            // blanco puro
  },
};


const vuetify = createVuetify({
  theme: {
    defaultTheme: 'azureTheme',
    themes: {
      azureTheme,
    },
  },
  defaults: {
    Vtoolbar:{
      color: 'fondo_toolbar',      // Fondo blanco
      height: '64px',      // Establecer una altura específica
      elevation: 2,        // Sombra ligera debajo
      flat: false,         // No plano, con sombra
      rounded: 'none',     // Sin bordes redondeados
      dense: false,        // No estilo denso
    },
    // Botones: tamaños, bordes y sombras.
    VBtn: {
      size: 'large', // Botones más grandes para accesibilidad
      rounded: 'md', // Bordes medianamente redondeados
      elevation: 1, // Sombra ligera como en Azure
      textColor: 'white',
      variant: 'flat', // Estilo plano pero destacable
    },

    // Tarjetas: Estilo limpio con separaciones.
    VCard: {
      elevation: 2, // Sombra ligera
      rounded: 'sm', // Bordes levemente redondeados
      color: 'surface', // Fondo blanco
    },

    // Campos de texto: Espaciados cómodos y bordes definidos.
    VTextField: {
      density: 'compact', // Más compacto para mayor alineación
      variant: 'outlined', // Bordes destacados
      color: 'primary', // Azul en foco
      labelColor: 'textSecondary', // Etiqueta más clara
    },

    // Selectores: Similar a campos de texto.
    VSelect: {
      density: 'compact',
      variant: 'outlined',
      color: 'primary',
    },

    // Tablas de datos: Inspiradas en el diseño limpio de Azure.
    VDataTable: {
      density: 'compact', // Espaciado ajustado pero cómodo
      elevation: 1, // Sombra ligera
      headers: {
        color: 'background', // Fondo claro en encabezados
        textColor: 'textPrimary', // Texto oscuro
      },
      row: {
        hoverColor: 'hover', // Fondo en hover
      },
    },

    // Diálogos y Modales.
    VDialog: {
      rounded: 'sm', // Bordes levemente redondeados
      elevation: 3, // Mayor sombra para destacar
    },

    // Contenedores: Tarjetas grandes como en Azure.
    VContainer: {
      color: 'background', // Fondo claro
      rounded: 'lg', // Bordes suaves
    },
  },
});

export default vuetify;
